export default __webpack_public_path__ + "static/media/Jim Risch.c8ab1a95.jpg";